import { render, staticRenderFns } from "./AddLanguageForm.vue?vue&type=template&id=0f50f2a4&"
import script from "./AddLanguageForm.vue?vue&type=script&lang=ts&"
export * from "./AddLanguageForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports